import { useEffect, useState, useCallback } from "react";
import { Mail, MailOpen, Phone } from "lucide-react";
import { api } from "@/lib/api";

export default function Inbox() {
  const [items, setItems] = useState([]);

  const load = useCallback(() => api.get("/messages").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const toggleRead = async (m) => {
    await api.patch(`/messages/${m.id}`, { read: !m.read });
    load();
  };

  return (
    <div data-testid="inbox-view">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Inbox</h1>
      <p className="text-slate-500 mt-1">Messages your AI receptionist took from callers.</p>

      <div className="mt-6 space-y-3">
        {items.length === 0 && <div className="rounded-xl border border-slate-200 bg-white p-10 text-center text-slate-400 text-sm">No messages yet.</div>}
        {items.map((m) => (
          <div
            key={m.id}
            data-testid="message-row"
            className={`rounded-xl border bg-white p-5 flex items-start gap-4 transition-all ${m.read ? "border-slate-200" : "border-blue-200 bg-blue-50/40"}`}
          >
            <div className={`h-10 w-10 rounded-lg flex items-center justify-center shrink-0 ${m.read ? "bg-slate-100 text-slate-400" : "bg-blue-100 text-blue-600"}`}>
              {m.read ? <MailOpen className="h-5 w-5" /> : <Mail className="h-5 w-5" />}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <p className="font-semibold text-slate-900">{m.customer_name}</p>
                {m.phone && <span className="text-xs text-slate-500 flex items-center gap-1"><Phone className="h-3 w-3" /> {m.phone}</span>}
                {!m.read && <span className="rounded-full bg-blue-600 text-white text-xs font-semibold px-2 py-0.5">New</span>}
              </div>
              <p className="text-sm text-slate-600 mt-1">{m.message}</p>
            </div>
            <button data-testid="toggle-read-btn" onClick={() => toggleRead(m)} className="text-xs font-medium text-blue-600 hover:underline shrink-0">
              {m.read ? "Mark unread" : "Mark read"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
